import {AnyElementType, DisplayType, Nullable} from "@data-force/app";
import {ArgsProps} from "antd/es/message";
import {
    ADD_ALERTS,
    CLEAR_ALERTS,
    REMOVE_ALERT,
    RENEW_SIGNED_MEDIA_URL,
    SET_BULK_CONFIRMATION_DIALOG_ACTION,
    SET_CONTENT_TYPE,
    SET_DISPLAY_TYPE,
    SET_FILE_SELECTION_TYPE,
    SET_JOB_SECTION_INSTRUCTIONS_VISIBLE,
    SET_JOB_SECTION_STATUS_STATS_VISIBLE,
    SET_NAVIGATION_ELEMENTS,
    SET_NAVIGATION_SELECTION,
    SET_SIGNED_RESOURCES_MAP,
    SET_USER_MENU_OPEN_KEYS,
    SET_USER_MENU_VISIBLE,
    SHOW_RESET_TASK_DIALOG,
    SHOW_UPLOAD_OVERLAY,
    TOGGLE_SIDEBAR,
} from "./availableActions";
import {
    AddAlertsAction,
    ClearAlertsAction,
    RemoveAlertAction,
    RenewSignedMediaUrlAction,
    SetBulkConfirmationDialogAction,
    SetContentTypeAction,
    SetDisplayTypeAction,
    SetFileSelectionTypeAction,
    SetJobSectionInstructionsVisible,
    SetNavigationElementsAction,
    SetNavigationSelectionAction,
    SetSignedResourcesMapAction,
    SetStatusStatsVisibleAction,
    SetUserMenuOpenKeysAction,
    SetUserMenuVisibleAction,
    ShowResetTaskDialogAction,
    ShowUploadOverlayAction,
    ToggleSidebarAction,
} from "../../interfaces/store/actions/layout";
import {BulkConfirmationPayload, ContentType, FileSelectionType} from "../../interfaces/store/actions/payload/layout";
import {SignedResourcesMap} from "../../interfaces/store/reducers/layoutState";

export const toggleSidebar = (): ToggleSidebarAction => ({
    type: TOGGLE_SIDEBAR,
});

export const setContentType = (payload: ContentType): SetContentTypeAction => ({
    type: SET_CONTENT_TYPE,
    payload,
});

export const setFileSelectionType = (payload: Nullable<FileSelectionType>): SetFileSelectionTypeAction => ({
    type: SET_FILE_SELECTION_TYPE,
    payload,
});

export const setDisplayType = (payload: DisplayType): SetDisplayTypeAction => ({
    type: SET_DISPLAY_TYPE,
    payload,
});

export const setNavigationElements = (payload: AnyElementType[]): SetNavigationElementsAction => ({
    type: SET_NAVIGATION_ELEMENTS,
    payload,
});

export const setNavigationSelection = (payload: number): SetNavigationSelectionAction => ({
    type: SET_NAVIGATION_SELECTION,
    payload,
});

export const setSignedResourcesMap = (payload: SignedResourcesMap): SetSignedResourcesMapAction => ({
    type: SET_SIGNED_RESOURCES_MAP,
    payload,
});

export const renewSignedMediaUrl = (payload: string): RenewSignedMediaUrlAction => ({
    type: RENEW_SIGNED_MEDIA_URL,
    payload,
});

export const showUploadOverlay = (payload: boolean): ShowUploadOverlayAction => ({
    type: SHOW_UPLOAD_OVERLAY,
    payload,
});

export const showResetTaskDialog = (payload: boolean): ShowResetTaskDialogAction => ({
    type: SHOW_RESET_TASK_DIALOG,
    payload,
});

export const setJobSectionInstructionsVisible = (payload: boolean): SetJobSectionInstructionsVisible => ({
    type: SET_JOB_SECTION_INSTRUCTIONS_VISIBLE,
    payload,
});

export const setBulkConfirmationDialog = (payload: BulkConfirmationPayload): SetBulkConfirmationDialogAction => ({
    type: SET_BULK_CONFIRMATION_DIALOG_ACTION,
    payload,
});

export const setStatusStatsVisible = (payload: boolean): SetStatusStatsVisibleAction => ({
    type: SET_JOB_SECTION_STATUS_STATS_VISIBLE,
    payload,
});

export const setUserMenuOpenKeys = (payload: string[]): SetUserMenuOpenKeysAction => ({
    type: SET_USER_MENU_OPEN_KEYS,
    payload,
});

export const setUserMenuVisible = (payload: boolean): SetUserMenuVisibleAction => ({
    type: SET_USER_MENU_VISIBLE,
    payload,
});

export const addAlerts = (payload: ArgsProps[]): AddAlertsAction => ({
    type: ADD_ALERTS,
    payload,
});

export const removeAlert = (payload: string | number): RemoveAlertAction => ({
    type: REMOVE_ALERT,
    payload,
});

export const clearAlerts = (): ClearAlertsAction => ({
    type: CLEAR_ALERTS,
});
